import { render, staticRenderFns } from "./dice.vue?vue&type=template&id=4cd971ff&scoped=true"
import script from "./dice.vue?vue&type=script&lang=js"
export * from "./dice.vue?vue&type=script&lang=js"
import style0 from "./dice.vue?vue&type=style&index=0&id=4cd971ff&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd971ff",
  null
  
)

export default component.exports